import gql from 'graphql-tag';

export const OVERALL_MORNINGSTAR_RATING = gql`
    query OverAllMorningStarRating($ticker: String!) {
        mutualFund(ticker: $ticker) {
            inceptionDate

            morningStarRatings {
                morningStarOverallRating
                morningStarOverallQuantity
                morningStarCategoryName
                morningStarAsOfDate: asOfDate
            }

            standardPerformanceReturns {
                monthlyAnnualReturns {
                    fundPerformance {
                        threeYearReturnTacked
                    }
                }
            }
        }
    }
`;

// This card is not used for ETFs, not sure why the query exists
// Leaving it for now, but removing it from the component so it
// doesn't accidentally get used, because things will break
export const ETF_OVERALL_MORNINGSTAR_RATING = gql`
    query ETFOverAllMorningStarRating($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            morningStarOverallRating
            morningStarOverallQuantity
            morningStarAsOfDate
            morningStarCategoryName
        }
    }
`;
